import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

const ExpandButton = () => {
  const [isMinimized, setIsMinimized] = useState(false);

  const requestFullscreen = () => {
    const el = document.documentElement;
    if (el.requestFullscreen && !document.fullscreenElement) {
      try {
        el.requestFullscreen();
      } catch (error) {
        console.error('Enter Fullscreen Error:', error);
      }
    } else {
      try {
        document.exitFullscreen();
      } catch (error) {
        console.error('Exit Fullscreen Error:', error);
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsMinimized(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  return (
    <ChildrensTooltip
      delayToRemove={100}
      placement="bottom"
      showOnHover={false}
      html="تمام صفحه"
    >
      <Button
        onClick={e => {
          e.preventDefault();
          requestFullscreen();
        }}
        variant="link"
        className="nav-link d-flex align-items-center pe-1"
      >
        <FontAwesomeIcon
          icon={!isMinimized ? 'expand-arrows-alt' : 'compress-arrows-alt'}
          className="fs-1"
        />
      </Button>
    </ChildrensTooltip>
  );
};

export default ExpandButton;
